module.exports = __webpack_public_path__ + "img/icon-settings-dark.22fcb7e4.svg";